import { templateJoin } from 'bernie-graphql';

export const activityDestinationViewSearchQuery = templateJoin`
        query ActivityDestinationViewSearch(
    $context: ContextInput!
    $destination: ActivityDestinationInput!
    $dateRange: ActivityDateRangeInput
    $sort: ActivitySort
    $filters: ActivitySearchFiltersInput
    $pagination: PaginationInput
    $marketing: ActivityMarketingInfoInput
    $searchViewOptions: [ActivitySearchViewOptions!]
) {
    activitySearch(
        context: $context
        destination: $destination
        dateRange: $dateRange
        sort: $sort
        filters: $filters
        pagination: $pagination
        marketing: $marketing
        searchViewOptions: $searchViewOptions
    ) {
        searchSummary {
            pageInfo {
                pageId
                pageName
                title
            }
            paginationInfo {
                pageSize
            }
            messages {
                index
                type
                title {
                    text
                    icon {
                        description
                        id
                        size
                        withBackground
                    }
                    mark {
                        description
                        id
                        url {
                            value
                        }
                    }
                }
                subtitle {
                    text
                    icon {
                        description
                        id
                        size
                        withBackground
                    }
                    mark {
                        description
                        id
                    }
                }
                action {
                    primary {
                        href
                        rfrr
                        text
                    }
                    secondary {
                        href
                        rfrr
                        text
                    }
                }
            }
            dateValidationResult {
                dateAdjusted
                formattedStartDate
                formattedEndDate
            }
            aboveTheFold {
                banners {
                    title
                    subtitle
                    icon {
                        description
                        id
                        size
                        withBackground
                    }
                    mark {
                        description
                        id
                    }
                    action {
                        href
                        text
                        rfrr
                    }
                    type
                }
                breadcrumbs {
                    label
                    selectionsToRemove {
                        id
                        value
                    }
                    analytics {
                        linkName
                        referrerId
                    }
                }
            }
            resolvedRegion {
                regionId
                regionName
                fullRegionName
            }
        }
        activityGroups {
            heading {
                ... on EGDSHeading {
                    text
                    headingType
                }
            }
            type
            viewType
            action {
                label
                accessibilityText
                url
                analytics {
                    linkName
                    referrerId
                }
            }
            analyticsList {
                linkName
                referrerId
            }
            activityTiles {
                __typename
                ... on ActivitySearchByKeywordTile {
                    dismiss {
                        description
                        id
                    }
                    icon {
                        description
                        id
                    }
                    analytics {
                        linkName
                        referrerId
                    }
                    clearAnalytics {
                        linkName
                        referrerId
                    }
                    searchTerm
                    placeholder
                }
                ... on Activity {
                    id
                    primary {
                        ... on EGDSHeading {
                            text
                            headingType
                        }
                    }
                    description
                    supplierName
                    clientSideAnalytics {
                        ... on ClientSideAnalytics {
                            linkName
                            referrerId
                        }
                    }
                    image {
                        description
                        url
                    }
                    cardBadges {
                        ... on ActivityCardBadges {
                            secondary {
                                ... on EGDSStandardBadge {
                                    text
                                    theme
                                    graphic {
                                        ... on Icon {
                                            description
                                            id
                                            size
                                        }
                                        ... on Mark {
                                            description
                                            id
                                        }
                                    }
                                }
                            }
                            primary {
                                ... on EGDSStandardBadge {
                                    text
                                    theme
                                    graphic {
                                        ... on Icon {
                                            description
                                            id
                                            size
                                        }
                                        ... on Mark {
                                            description
                                            id
                                        }
                                    }
                                }
                            }
                        }
                    }
                    activityDuration {
                        ... on EGDSIconText {
                            text
                            icon {
                                id
                            }
                        }
                    }
                    features {
                        volumePricing {
                            description
                        }
                        freeCancellationFeature {
                            ... on EGDSStylizedText {
                                text
                                theme
                                weight
                            }
                        }
                        loyaltyEarnAwards {
                            mark {
                                id
                                url {
                                    value
                                }
                            }
                            label
                        }
                        pinnedTopBottom {
                            tileTop {
                                description
                            }
                            tileBottom {
                                id
                                description
                            }
                        }
                        likelyToSellOut {
                            formatted
                        }
                        travelDistance {
                            label
                        }
                        hotelPickup {
                            icon_temp {
                                id
                            }
                            label
                        }
                        enhancedCleaningFeature {
                            ... on EGDSIconText {
                                text
                                icon {
                                    id
                                    size
                                }
                            }
                        }
                    }
                    leadTicketPrice {
                        __typename
                        priceLockup {
                            ... on EGDSPriceLockup {
                                __typename
                                priceSubtextFirst
                                priceSubtextStandard
                                lockupPrice
                                strikeThroughPrice
                                accessibilityStrikeThroughDialogTrigger
                                accessibilityPrice
                                lockupFormattedPoints
                                leadingCaption
                                isPointsFirst
                                isStrikeThroughFirst
                            }
                        }
                        disclaimer {
                            ... on ActivityDisclaimerDialog {
                                __typename
                                dialog {
                                    ... on EGDSActionDialog {
                                        closeAnalytics {
                                            ... on ClientSideAnalytics {
                                                linkName
                                                referrerId
                                            }
                                        }
                                        footer {
                                            ... on EGDSInlineDialogFooter {
                                                buttons {
                                                    ... on UITertiaryButton {
                                                        accessibility
                                                        primary
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                trigger {
                                    ... on ActivityGraphicDialogTrigger {
                                        analytics {
                                            ... on ClientSideAnalytics {
                                                linkName
                                                referrerId
                                            }
                                        }
                                        accessibility
                                        graphic {
                                            ... on Icon {
                                                id
                                                description
                                            }
                                        }
                                    }
                                }
                                contents {
                                    ... on EGDSPlainText {
                                        text
                                    }
                                }
                                dialogActions {
                                    ... on ActivityLinkClickAction {
                                         accessibilityText
                                          analytics {
                                          ... on ActivityAnalytics {
                                            linkName
                                            referrerId
                                            }
                                          }
                                          opensInNewTab
                                          linkTagUrl
                                          anchorTagUrl
                                    }
                                }
                            }
                        }
                    }
                    reviewSummary {
                        reviewRatingMessage
                        reviewCountMessage
                        source
                        blockWebCrawlersEnabled
                        reviewRatingAccessibilityText
                        averageScore {
                            ... on EGDSStylizedText {
                                __typename
                                text
                                weight
                            }
                        }
                        total
                        disclaimer {
                            ... on ActivityDisclaimerDialog {
                                __typename
                                dialog {
                                    ... on EGDSActionDialog {
                                        closeAnalytics {
                                            ... on ClientSideAnalytics {
                                                linkName
                                                referrerId
                                            }
                                        }
                                        footer {
                                            ... on EGDSInlineDialogFooter {
                                                buttons {
                                                    ... on UITertiaryButton {
                                                        accessibility
                                                        primary
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                trigger {
                                    ... on ActivityLinkDialogTrigger {
                                        analytics {
                                            ... on ClientSideAnalytics {
                                                linkName
                                                referrerId
                                            }
                                        }
                                        accessibility
                                        label
                                        graphic {
                                            ... on Icon {
                                                id
                                                description
                                            }
                                        }
                                    }
                                }
                                contents {
                                    ... on EGDSParagraph {
                                        style
                                        text
                                    }
                                }
                                dialogActions {
                                    ... on ActivityLinkClickAction {
                                         accessibilityText
                                          analytics {
                                          ... on ActivityAnalytics {
                                            linkName
                                            referrerId
                                            }
                                          }
                                          opensInNewTab
                                          linkTagUrl
                                          anchorTagUrl
                                    }
                                }
                            }
                        }
                        sectionRef
                    }
                    saveItem {
                        initialChecked
                        itemId
                        source
                        attributes {
                            ... on TripsSaveActivityAttributes {
                                regionId
                                dateRange {
                                    start {
                                        day
                                        month
                                        year
                                        __typename
                                    }
                                    end {
                                        day
                                        month
                                        year
                                        __typename
                                    }
                                    __typename
                                }
                            }
                            __typename
                        }
                        save {
                            accessibility
                            analytics {
                                referrerId
                                linkName
                                __typename
                            }
                            label
                            __typename
                        }
                        remove {
                            accessibility
                            analytics {
                                referrerId
                                linkName
                                __typename
                            }
                            label
                            __typename
                        }
                        __typename
                    }
                    thirdPartyPartnerName
                    clickAction {
                        openInNewTab
                        uri {
                            relativePath
                        }
                    }
                    imageCarousel {
                        __typename
                        items {
                            __typename
                            ...on EGDSMediaCarouselItem {
                                media {
                                    __typename
                                    ...on ActivityMediaItem {
                                        media {
                                            __typename
                                            ...on Image {
                                                __typename
                                                description
                                                url
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        nextButton {
                            accessibility
                            analytics {
                                referrerId
                                linkName
                            }
                        }
                        previousButton {
                            accessibility
                            analytics {
                                referrerId
                                linkName
                            }
                        }
                    }
                }
                ... on ActivityBasicTile {
                    primary {
                        ... on EGDSHeading {
                            text
                            headingType
                        }
                        ... on EGDSPlainText {
                            text
                        }
                    }
                    link
                    image {
                        description
                        url
                    }
                    clientSideAnalytics {
                        ... on ClientSideAnalytics {
                            linkName
                            referrerId
                        }
                    }
                    secondaryMessage
                    enabled
                }
                ... on ActivityActionTile {
                    __typename
                    primaryAction {
                        url
                        label
                        clickAnalytics {
                            ... on ClientSideAnalytics {
                                linkName
                                referrerId
                            }
                        }
                        icon {
                            id
                        }
                    }
                }
                ... on ActivityMessageTile {
                    type
                    title {
                        text
                    }
                    subtitle {
                        text
                    }
                    action {
                        first {
                            text
                            clickAction {
                                __typename
                                analytics {
                                    microMessagePayload
                                    linkName
                                    referrerId
                                }
                                ... on ActivityLinkClickAction {
                                    linkTagUrl
                                    anchorTagUrl
                                    opensInNewTab
                                    accessibilityText
                                }
                                ... on ActivityPopupClickAction {
                                    dismissAction {
                                        text
                                        href
                                        rfrr
                                    }
                                    title
                                    messages
                                }
                            }
                        }
                        second {
                            text
                            clickAction {
                                __typename
                                analytics {
                                    microMessagePayload
                                    linkName
                                    referrerId
                                }
                                ... on ActivityLinkClickAction {
                                    linkTagUrl
                                    anchorTagUrl
                                    opensInNewTab
                                    accessibilityText
                                }
                                ... on ActivityPopupClickAction {
                                    dismissAction {
                                        text
                                        href
                                        rfrr
                                    }
                                    title
                                    messages
                                }
                            }
                        }
                    }
                    icon {
                        description
                        id
                        withBackground
                        size
                    }
                    mark {
                        description
                        id
                        url {
                            value
                        }
                    }
                    analytics {
                        linkName
                        referrerId
                    }
                }
                ... on ActivityTextTile {
                    anchoredText {
                        clickAction {
                            analytics {
                                linkName
                                referrerId
                            }
                            ... on ActivityLinkClickAction {
                                anchorTagUrl
                                opensInNewTab
                                accessibilityText
                            }
                        }
                        icon {
                            id
                            description
                        }
                        text
                    }
                    activityText {
                        ... on ActivityText {
                            __typename
                            text
                            size
                        }
                    }
                    alignment
                }
                ... on ActivityAssortedComponentsTile {
                    sortSection {
                        ... on ShoppingSortAndFilterSection {
                            fields {
                                ... on ShoppingDropdownField {
                                    __typename
                                    primary
                                    options {
                                        primary
                                        value
                                        selected
                                        disabled
                                        selectAnalytics {
                                            linkName
                                            referrerId
                                        }
                                    }
                                }
                            }
                        }
                    }
                    shopWithPoints {
                        ... on ActivityToggle {
                            checked
                            checkedLabel
                            uncheckedLabel
                            checkedAnalytics {
                                linkName
                                referrerId
                            }
                            uncheckedAnalytics {
                                linkName
                                referrerId
                            }
                        }
                    }
                    sortDisclaimer {
                        text
                        icon {
                            id
                            description
                        }
                        clickAction {
                            ... on ActivityLinkClickAction {
                                anchorTagUrl
                                analytics {
                                    linkName
                                    referrerId
                                }
                                accessibilityText
                                opensInNewTab
                            }
                        }
                    }
                    pills {
                        appliedFilters {
                            nextSearchCriteria {
                                selections {
                                    id
                                    value
                                }
                            }
                            pill {
                                primary
                                accessibility
                                action {
                                    ... on ShoppingSortAndFilterAction {
                                        analytics {
                                            linkName
                                            referrerId
                                        }
                                    }
                                }
                            }
                        }
                        clearAll {
                            ... on UITertiaryButton {
                                primary
                                action {
                                    ... on UILinkAction {
                                        analytics {
                                            linkName
                                            referrerId
                                        }
                                        resource {
                                            ... on HttpURI {
                                                relativePath
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                ... on ActivityEmptyStateTile {
                    heading
                    body
                    icon {
                        id
                        description
                    }
                }
            }
        }
        universalSortAndFilter {
            ... on ShoppingSortAndFilters {
                applyAction {
                    ... on UIPrimaryFloatingActionButton {
                        primary
                        accessibility
                        action {
                            ... on ShoppingSortAndFilterAction {
                                analytics {
                                    referrerId
                                    linkName
                                }
                            }
                        }
                    }
                }
                revealAction {
                    ... on UISecondaryFloatingActionButton {
                        primary
                        accessibility
                        badge
                        action {
                            ... on ShoppingSortAndFilterAction {
                                analytics {
                                    referrerId
                                    linkName
                                }
                            }
                        }
                    }
                }
                toolbar {
                    primary
                    actions {
                        ... on UIToolbarActions {
                            primary {
                                accessibility
                            }
                            secondaries {
                                primary
                                accessibility
                                action {
                                    ... on ShoppingSortAndFilterAction {
                                        analytics {
                                            referrerId
                                            linkName
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                clearAll {
                    ... on UITertiaryButton {
                        primary
                        action {
                            ... on UILinkAction {
                                analytics {
                                    linkName
                                    referrerId
                                }
                                resource {
                                    ... on HttpURI {
                                        relativePath
                                    }
                                }
                            }
                        }
                    }
                }
                appliedFilters {
                    ... on EGDSSortAndFilterAppliedFilter {
                        pill {
                            primary
                            accessibility
                            action {
                                ... on ShoppingSortAndFilterAction {
                                    analytics {
                                        linkName
                                        referrerId
                                    }
                                }
                            }
                        }
                        nextSearchCriteria {
                            selections {
                                id
                                value
                            }
                        }
                    }
                }
                sortSections {
                    ... on ShoppingSortAndFilterSection {
                        fields {
                            ... on ShoppingDropdownField {
                                __typename
                                primary
                                options {
                                    ... on ShoppingSelectableFilterOption {
                                        id
                                        value
                                        primary
                                        selected
                                        secondary
                                        disabled
                                        icon {
                                            id
                                            description
                                        }
                                        selectAnalytics {
                                            linkName
                                            referrerId
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                filterSections {
                    ... on ShoppingSortAndFilterSection {
                        title
                        fields {
                            ... on ShoppingTextInputField {
                                __typename
                                id
                                label
                                placeholder
                                icon {
                                    id
                                }
                                analytics {
                                    linkName
                                    referrerId
                                }
                                selected
                            }
                            ... on ShoppingMultiSelectionField {
                                __typename
                                primary
                                options {
                                    ... on ShoppingSelectableFilterOption {
                                        value
                                        id
                                        primary
                                        selected
                                        description
                                        disabled
                                        selectAnalytics {
                                            linkName
                                            referrerId
                                        }
                                        deselectAnalytics {
                                            linkName
                                            referrerId
                                        }
                                        nestedOptions {
                                            value
                                            id
                                            primary
                                            selected
                                            description
                                            disabled
                                            selectAnalytics {
                                                linkName
                                                referrerId
                                            }
                                            deselectAnalytics {
                                                linkName
                                                referrerId
                                            }
                                        }
                                        accessibility
                                    }
                                }
                            }
                            ... on ShoppingSelectionField {
                                __typename
                                primary
                                options {
                                    ... on ShoppingSelectableFilterOption {
                                        id
                                        value
                                        primary
                                        selected
                                        description
                                        disabled
                                        selectAnalytics {
                                            linkName
                                            referrerId
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

    `;

export const activityDetailOffersQuery = templateJoin`
        query ActivityDetailOffers(
    $context: ContextInput!
    $activityId: String!
    $destination: ActivityDestinationInput
    $dateRange: ActivityDateRangeInput
    $marketing: ActivityMarketingInfoInput
    $detailsViewOptions: [ActivityDetailViewOptions!]
    $offerFilters: ActivityOfferFilterInput
) {
    activityInfo(
        context: $context
        activityId: $activityId
        destination: $destination
        dateRange: $dateRange
        marketing: $marketing
        detailsViewOptions: $detailsViewOptions
        offerFilters: $offerFilters
    ) {
        offers(filter: $offerFilters) {
            activityOfferTicketsSummary {
                title
                icon
            }
            availableTimeEpoch
            formattedAvailableTime
            availableTime {
                day
                hour
                minute
                month
                second
                year
                epochSeconds
                formatted(format: "yyyy-MM-dd HH:mm:ss")
                fullDateFormat
                raw
                shortDateFormat
                shortTimeFormat
            }
            priceMetaData {
                discountType
                discountPercent
            }
            activityOfferMessages {
                vbpMessage
                likelyToSellOut{
                    formatted
                }
                operatingHours {
                    text
                }
            }
            badges {
                secondary {
                    text
                    type
                    icon {
                        description
                        id
                        size
                        withBackground
                    }
                    mark {
                        description
                        id
                    }
                }
                primary {
                    text
                    type
                    mark {
                        description
                        id
                    }
                    icon {
                        description
                        id
                        size
                        withBackground
                    }
                }
            }
            description
            features {
                icon {
                    description
                    id
                    size
                    withBackground
                }
                mark {
                    description
                    id
                    url {
                        value
                    }
                }
                label
                subtext
                url
                anchoredSubtext {
                    clickAction {
                        ...on ActivityPopupClickAction {
                            messages
                            dismissAction {
                                href
                                rfrr
                                text
                            }
                        }
                        analytics {
                            linkName
                            referrerId
                        }
                    }
                    icon {
                        description
                        id
                    }
                    text
                }
            }
            id
            promoId
            name
            maxTicketSelectionAllowed
            hotelPickupAvailable
            priceType
            count
            priceSummary {
                totalPriceSummary{
                    title
                    priceAccessibilityText
                    loyaltyPointsMessage
                    pointsFirst
                    legalDisclaimer{
                        clickAction {
                            ... on ActivityPopupClickAction {
                                messages
                                dismissAction {
                                    href
                                    rfrr
                                    text
                                }
                            }
                            analytics {
                                linkName
                                referrerId
                            }
                        }
                        icon {
                            description
                            id
                        }
                        text
                        accessibilityText
                    }
                    price{
                        strikeOut{
                            formatted
                        }
                        lead{
                            formatted
                        }

                    }

                }
                ticketBreakdownSummary{
                    title
                    ticketTypePrices{
                        accessibilityText
                        breakdownLeadPriceLabel
                        breakdownStrikeOutPriceLabel
                        totalLeadPriceLabel
                    }

                }
            }
            ticketTypes {
                maxSelectableCount
                minSelectableCount
                step
                type
                defaultSelectedCount
                label
                promoId
                restrictionText
                ticketKey
                ticketSingular
                ticketPlural
                prices {
                    selectedCount
                    perTravelerPrice {
                        lead {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                        strikeOut {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                    }
                    totalPrice {
                        lead {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                        strikeOut {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                    }
                    totalLoyaltyPointsOption {
                        pointsAmount {
                            raw
                        }
                        pointsUnit
                        leadingCaption
                        pointsFirst
                        strikeThroughFirst
                    }
                }
            }
            selections {
                id
                title
                fields {
                    label
                    theme
                    value
                }
                graphic {
                    ... on Icon {
                        description
                        id
                    }
                }
            }
        }
        recommendation {
            title
        }

        offersSummary {
            filters {
                id
                title
                fields {
                    label
                    theme
                    value
                }
            }
        }
    }
}

    `;

export const activityDetailBasicQuery = templateJoin`
        query ActivityDetailBasic(
    $context: ContextInput!
    $activityId: String!
    $dateRange: ActivityDateRangeInput
    $destination: ActivityDestinationInput
    $marketing: ActivityMarketingInfoInput
    $detailsViewOptions: [ActivityDetailViewOptions!]
    $offerFilters: ActivityOfferFilterInput
) {
    activityInfo(
        context: $context
        activityId: $activityId
        dateRange: $dateRange
        destination: $destination
        marketing: $marketing
        detailsViewOptions: $detailsViewOptions
        offerFilters: $offerFilters
    ) {
        telesales {
            label
            phoneNumberLink {
                phoneNumber
                value
            }
            analytics {
                linkName
                referrerId
            }
        }
        tabbedNavigationBar {
            tabs {
                label
                sectionRef
                analytics {
                    linkName
                    referrerId
                }
            }
        }
        availabilities {
            date {
                isoFormat
                day
                month
                year
                fullDateFormat
            }
            isAvailable
            price {
                formatted
            }
            priceTextTheme
        }
        availabilityCalendar {
            date {
                isoFormat
            }
            price {
                formatted
            }
        }
        location {
            event {
                coordinates {
                    latitude
                    longitude
                }
                address {
                    firstLine
                    secondLine
                    thirdLine
                    city
                    province
                    zipCode
                    country
                }
                description
                region {
                    regionId
                    regionName
                    fullRegionName
                }
            }
            redemption {
                address {
                    firstLine
                    secondLine
                    thirdLine
                    province
                    city
                    zipCode
                    country
                }
                description
                coordinates {
                    latitude
                    longitude
                }
                distanceFromHotel {
                    text
                    size
                }
            }
            sectionRef
        }
        gallery {
            featuredMedia {
                __typename
                ... on Image {
                    description
                    url
                    thumbnailClickAnalytics {
                        linkName
                        referrerId
                    }
                }
                ... on Video {
                    description
                    videoUrl: url {
                        ... on HttpURI {
                            value
                            relativePath
                        }
                    }
                    playPauseAnalytics {
                        linkName
                        referrerId
                    }
                    thumbnailClickAnalytics {
                        linkName
                        referrerId
                    }
                }
            }
            medias {
                __typename
                ... on Image {
                    description
                    url
                    thumbnailClickAnalytics {
                        linkName
                        referrerId
                    }
                }
                ... on Video {
                    description
                    videoUrl: url {
                        ... on HttpURI {
                            value
                            relativePath
                        }
                    }
                    playPauseAnalytics {
                        linkName
                        referrerId
                    }
                    thumbnailClickAnalytics {
                        linkName
                        referrerId
                    }
                }
            }
        }
        uisPayload {
            detailsPayload
        }
        presentation {
            partnerProvidedDetails {
                heading
                body
            }
            title
            staticMap
            detailsSectionGroups {
                footer
                heading
                sectionRef
                sections {
                    heading
                    headingGraphic {
                        ... on Icon {
                            description
                            id
                            size
                            token
                        }
                    }
                    sectionRefLink {
                        analytics {
                            microMessagePayload
                            linkName
                            referrerId
                        }
                        label
                        sectionRef
                    }
                    structuredItems {
                        icon_temp {
                            description
                            id
                            size
                            token
                        }
                        label
                    }
                }
            }
            pointsToRemember {
                __typename
                headingGraphic {
                    ... on Icon {
                        description
                        id
                    }
                }
                key
                heading
                items
                structuredItems {
                    icon {
                        description
                        id
                    }
                    label
                }
                sectionRef
                sectionRefLink {
                    analytics {
                        microMessagePayload
                        linkName
                        referrerId
                    }
                    ... on ActivityRefClickAction {
                        label
                        sectionRef
                    }
                }
                expando {
                    expandLabel
                    collapseLabel
                    expandAnalytics {
                        linkName
                        referrerId
                    }
                }
            }
            banners {
                title
                subtitle
                icon {
                    description
                    id
                    size
                    withBackground
                }
                mark {
                    description
                    id
                }
                type
                action {
                    rfrr
                    href
                    text
                }
            }
            features {
                label
                subtext
                url
                icon {
                    description
                    id
                }
                mark {
                    description
                    id
                    url {
                        value
                    }
                }
            }
            loyaltyPointsValue {
                formatted
                currencyInfo {
                    code
                    name
                    symbol
                }
                amount
            }
            promotionMessage {
                type
                mark {
                    description
                    id
                }
                icon {
                    description
                    id
                    size
                    withBackground
                }
                subtitle
                title
                action {
                    primary {
                        __typename
                        text
                        url
                    }
                    secondary {
                        __typename
                        text
                        url
                    }
                }
                clickAction {
                    first {
                        text
                        clickAction {
                            __typename
                            analytics {
                                microMessagePayload
                                linkName
                                referrerId
                            }
                            ... on ActivityLinkClickAction {
                                accessibilityText
                                linkTagUrl
                                anchorTagUrl
                                opensInNewTab
                            }
                            ... on ActivityPopupClickAction {
                                dismissAction {
                                    text
                                    href
                                    rfrr
                                }
                                title
                                messages
                            }
                        }
                    }
                    second {
                        text
                        clickAction {
                            __typename
                            analytics {
                                microMessagePayload
                                linkName
                                referrerId
                            }
                            ... on ActivityLinkClickAction {
                                accessibilityText
                                linkTagUrl
                                anchorTagUrl
                                opensInNewTab
                            }
                            ... on ActivityPopupClickAction {
                                dismissAction {
                                    text
                                    href
                                    rfrr
                                }
                                title
                                messages
                            }
                        }
                    }
                }
                analytics {
                    linkName
                    referrerId
                }
            }
            legalDisclaimer {
                icon {
                    id
                    withBackground
                }
                title
            }
            localisationDisclaimer {
                icon {
                    withBackground
                    id
                }
                title
                action {
                    href
                    text
                    accessibilityText
                }
                secondaryAction {
                    href
                    text
                    accessibilityText
                }
            }
        }
        activity {
            supplierName
            reviewSummary {
                reviewCountMessage
                source
                blockWebCrawlersEnabled
                score {
                    formatted
                    raw
                }
                total
                disclaimer {
                    ... on ActivityDisclaimerDialog {
                        __typename
                        dialog {
                            ... on EGDSActionDialog {
                                closeAnalytics {
                                    ... on ClientSideAnalytics {
                                        linkName
                                        referrerId
                                    }
                                }
                                footer {
                                    ... on EGDSInlineDialogFooter {
                                        buttons {
                                            ... on UITertiaryButton {
                                                accessibility
                                                primary
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        trigger {
                            ... on ActivityLinkDialogTrigger {
                                analytics {
                                    ... on ClientSideAnalytics {
                                        linkName
                                        referrerId
                                    }
                                }
                                accessibility
                                label
                                graphic {
                                    ... on Icon {
                                        id
                                        description
                                    }
                                }
                            }
                        }
                        contents {
                            ... on EGDSParagraph {
                                style
                                text
                            }
                        }
                        dialogActions {
                            ... on ActivityLinkClickAction {
                              accessibilityText
                              analytics {
                                linkName
                                referrerId
                              }
                              opensInNewTab
                              linkTagUrl
                            }
                        }
                    }
                }
                sectionRef
            }
            description
            name
            image {
                description
                url
            }
            id
            redemption {
                type
            }
            sectionRef
        }
        offersSummary {
            leadTicketView {
                action {
                    text
                }
                message
                ticket {
                    label
                    price {
                        lead {
                            formatted
                            amount
                        }
                        strikeOut {
                            formatted
                            amount
                        }
                    }
                    loyaltyPointsOption {
                        formattedPoints
                        leadingCaption
                        pointsFirst
                        strikeThroughFirst
                    }
                    priceAccessibilityText
                    likelyToSellOut {
                        formatted
                    }
                    legalDisclaimer {
                        clickAction {
                            ... on ActivityPopupClickAction {
                                messages
                                dismissAction {
                                    href
                                    rfrr
                                    text
                                }
                            }
                            analytics {
                                linkName
                                referrerId
                            }
                        }
                        icon {
                            description
                            id
                        }
                        text
                        accessibilityText
                    }
                }
            }
            filters {
                id
                title
                fields {
                    label
                    theme
                    value
                }
            }
        }
        offers(filter: $offerFilters) {
            activityOfferTicketsSummary {
                title
                icon
            }
            availableTimeEpoch
            formattedAvailableTime
            availableTime {
                day
                hour
                minute
                month
                second
                year
                epochSeconds
                formatted(format: "yyyy-MM-dd HH:mm:ss")
                fullDateFormat
                raw
                shortDateFormat
                shortTimeFormat
            }
            priceMetaData {
                discountType
                discountPercent
            }
            activityOfferMessages {
                vbpMessage
                likelyToSellOut {
                    formatted
                }
                nonRefundable {
                    title
                    subTitle
                }
                operatingHours {
                    text
                }
            }
            badges {
                secondary {
                    text
                    type
                    icon {
                        description
                        id
                        size
                        withBackground
                    }
                    mark {
                        description
                        id
                    }
                }
                primary {
                    text
                    type
                    mark {
                        description
                        id
                    }
                    icon {
                        description
                        id
                        size
                        withBackground
                    }
                }
            }
            description
            features {
                icon {
                    description
                    id
                    size
                    withBackground
                }
                mark {
                    description
                    id
                    url {
                        value
                    }
                }
                label
                subtext
                url
                anchoredSubtext {
                    clickAction {
                        ... on ActivityPopupClickAction {
                            messages
                            dismissAction {
                                href
                                rfrr
                                text
                            }
                        }
                        analytics {
                            linkName
                            referrerId
                        }
                    }
                    icon {
                        description
                        id
                    }
                    text
                }
            }
            id
            promoId
            name
            maxTicketSelectionAllowed
            hotelPickupAvailable
            priceType
            count
            priceSummary {
                totalPriceSummary {
                    title
                    priceAccessibilityText
                    loyaltyPointsMessage
                    pointsFirst
                    legalDisclaimer {
                        clickAction {
                            ... on ActivityPopupClickAction {
                                messages
                                dismissAction {
                                    href
                                    rfrr
                                    text
                                }
                            }
                            analytics {
                                linkName
                                referrerId
                            }
                        }
                        icon {
                            description
                            id
                        }
                        text
                        accessibilityText
                    }
                    price {
                        strikeOut {
                            formatted
                        }
                        lead {
                            formatted
                        }
                    }
                }
                ticketBreakdownSummary {
                    title
                    ticketTypePrices {
                        accessibilityText
                        breakdownLeadPriceLabel
                        breakdownStrikeOutPriceLabel
                        totalLeadPriceLabel
                    }
                }
            }
            ticketTypes {
                maxSelectableCount
                minSelectableCount
                step
                type
                defaultSelectedCount
                label
                promoId
                restrictionText
                ticketKey
                ticketSingular
                ticketPlural
                prices {
                    selectedCount
                    perTravelerPrice {
                        lead {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                        strikeOut {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                    }
                    totalPrice {
                        lead {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                        strikeOut {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                    }
                    totalLoyaltyPointsOption {
                        pointsAmount {
                            raw
                        }
                        pointsUnit
                        leadingCaption
                        pointsFirst
                        strikeThroughFirst
                    }
                }
            }
            selections {
                id
                title
                fields {
                    label
                    theme
                    value
                }
                graphic {
                    ... on Icon {
                        description
                        id
                    }
                }
            }
        }
    }
}

    `;

export const activityDetailOfferQuery = templateJoin`
        query ActivityDetailOffer(
    $context: ContextInput!
    $activityId: String!
    $destination: ActivityDestinationInput
    $dateRange: ActivityDateRangeInput
    $marketing: ActivityMarketingInfoInput
    $offerId: String!
    $filter: ActivityOfferFilterInput!
    $detailsViewOptions: [ActivityDetailViewOptions!]
    $offerFilters: ActivityOfferFilterInput
) {
    activityInfo(
        context: $context
        activityId: $activityId
        destination: $destination
        dateRange: $dateRange
        marketing: $marketing
        detailsViewOptions: $detailsViewOptions
        offerFilters: $offerFilters
    ) {
        offer(offerId: $offerId, filter: $filter) {

            activityOfferTicketsSummary{
                title
                icon
            }
            availableTimeEpoch
            formattedAvailableTime
            availableTime {
                epochSeconds
                formatted(format: "yyyy-MM-dd HH:mm:ss")
            }
            priceMetaData {
                discountType
                discountPercent
            }
            activityOfferMessages {
                vbpMessage
                likelyToSellOut{
                    formatted
                }
                operatingHours {
                    text
                }
            }
            badges {
                secondary {
                    text
                    type
                    mark {
                        description
                        id
                    }
                    icon {
                        description
                        id
                        size
                        withBackground
                    }
                }
                primary {
                    text
                    type
                    mark {
                        description
                        id
                    }
                    icon {
                        description
                        id
                        size
                        withBackground
                    }
                }
            }
            description
            features {
                icon {
                    description
                    id
                }
                mark {
                    description
                    id
                    url {
                        value
                    }
                }
                label
                subtext
                url
                anchoredSubtext {
                    clickAction {
                        ...on ActivityPopupClickAction {
                            messages
                            dismissAction {
                                href
                                rfrr
                                text
                            }
                        }
                        analytics {
                            linkName
                            referrerId
                        }
                    }
                    icon {
                        description
                        id
                    }
                    text
                }
            }
            id
            promoId
            name
            maxTicketSelectionAllowed
            hotelPickupAvailable
            priceType
            count
            priceSummary {
                totalPriceSummary{
                    title
                    priceAccessibilityText
                    loyaltyPointsMessage
                    pointsFirst
                    legalDisclaimer{
                        clickAction {
                            ... on ActivityPopupClickAction {
                                messages
                                dismissAction {
                                    href
                                    rfrr
                                    text
                                }
                            }
                            analytics {
                                linkName
                                referrerId
                            }
                        }
                        icon {
                            description
                            id
                        }
                        text
                        accessibilityText
                    }
                    price{
                        strikeOut{
                            formatted
                        }
                        lead{
                            formatted
                        }

                    }

                }
                ticketBreakdownSummary{
                    title
                    ticketTypePrices{
                        accessibilityText
                        breakdownLeadPriceLabel
                        breakdownStrikeOutPriceLabel
                        totalLeadPriceLabel
                    }

                }
            }
            ticketTypes {
                maxSelectableCount
                minSelectableCount
                step
                defaultSelectedCount
                type
                label
                promoId
                restrictionText
                ticketKey
                ticketSingular
                ticketPlural
                prices {
                    selectedCount
                    perTravelerPrice {
                        lead {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                        strikeOut {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                    }
                    totalPrice {
                        lead {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                        strikeOut {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                    }
                    totalLoyaltyPointsOption {
                        pointsAmount {
                            raw
                        }
                        pointsUnit
                        leadingCaption
                        pointsFirst
                        strikeThroughFirst
                    }
                }
            }
            selections {
                id
                title
                fields {
                    label
                    theme
                    value
                }
                graphic {
                    ... on Icon {
                        description
                        id
                    }
                }
            }
        }
    }
}

    `;

export const activityDetailOffersWithAvailabilityQuery = templateJoin`
        query ActivityDetailOffersWithAvailability(
    $context: ContextInput!
    $activityId: String!
    $dateRange: ActivityDateRangeInput
    $destination: ActivityDestinationInput
    $marketing: ActivityMarketingInfoInput
    $detailsViewOptions: [ActivityDetailViewOptions!]
) {
    activityInfo(
        context: $context
        activityId: $activityId
        dateRange: $dateRange
        destination: $destination
        marketing: $marketing
        detailsViewOptions: $detailsViewOptions
    ) {
        availabilities {
            date {
                isoFormat
                day
                month
                year
                fullDateFormat
            }
            isAvailable
            price {
                formatted
            }
            priceTextTheme
        }
        availabilityCalendar {
            date {
                isoFormat
            }
            price {
                formatted
            }
        }
        presentation {
            banners {
                title
                subtitle
                icon {
                    description
                    id
                    size
                    withBackground
                }
                mark {
                    description
                    id
                }
                type
                action {
                    rfrr
                    href
                    text
                }
            }
            promotionMessage {
                type
                mark {
                    description
                    id
                }
                icon {
                    description
                    id
                    size
                    withBackground
                }
                subtitle
                title
                action {
                    primary {
                        text
                        url
                    }
                    secondary {
                        text
                        url
                    }
                }
                analytics {
                    linkName
                    referrerId
                }
            }
        }
        uisPayload {
            detailsPayload
        }
        offersSummary {
            leadTicketView {
                action {
                    text
                }
                message
                ticket {
                    label
                    price {
                        lead {
                            formatted
                            amount
                        }
                    }
                    likelyToSellOut{
                        formatted
                    }
                }
            }
            filters {
                id
                title
                fields {
                    label
                    theme
                    value
                }
            }
        }
        offers {
            activityOfferTicketsSummary{
                title
                icon
            }
            availableTimeEpoch
            formattedAvailableTime
            availableTime {
                day
                hour
                minute
                month
                second
                year
                epochSeconds
                formatted(format: "yyyy-MM-dd HH:mm:ss")
                fullDateFormat
                raw
                shortDateFormat
                shortTimeFormat
            }
            priceMetaData {
                discountType
                discountPercent
            }
            activityOfferMessages {
                vbpMessage
                likelyToSellOut{
                    formatted
                }
                operatingHours {
                    text
                }
            }
            badges {
                secondary {
                    text
                    type
                    mark {
                        description
                        id
                    }
                    icon {
                        description
                        id
                        size
                        withBackground
                    }
                }
                primary {
                    text
                    type
                    mark {
                        description
                        id
                    }
                    icon {
                        description
                        id
                        size
                        withBackground
                    }
                }
            }
            description
            features {
                icon {
                    description
                    id
                }
                mark {
                    description
                    id
                    url {
                        value
                    }
                }
                label
                subtext
                url
                anchoredSubtext {
                    clickAction {
                        ...on ActivityPopupClickAction {
                            messages
                            dismissAction {
                                href
                                rfrr
                                text
                            }
                        }
                        analytics {
                            linkName
                            referrerId
                        }
                    }
                    icon {
                        description
                        id
                    }
                    text
                }
            }
            id
            promoId
            name
            maxTicketSelectionAllowed
            hotelPickupAvailable
            priceType
            count
            priceSummary {
                totalPriceSummary{
                    title
                    priceAccessibilityText
                    loyaltyPointsMessage
                    pointsFirst
                    legalDisclaimer{
                        clickAction {
                            ... on ActivityPopupClickAction {
                                messages
                                dismissAction {
                                    href
                                    rfrr
                                    text
                                }
                            }
                            analytics {
                                linkName
                                referrerId
                            }
                        }
                        icon {
                            description
                            id
                        }
                        text
                        accessibilityText
                    }
                    price{
                        strikeOut{
                            formatted
                        }
                        lead{
                            formatted
                        }

                    }

                }
                ticketBreakdownSummary{
                    title
                    ticketTypePrices{
                        accessibilityText
                        breakdownLeadPriceLabel
                        breakdownStrikeOutPriceLabel
                        totalLeadPriceLabel
                    }

                }
            }
            ticketTypes {
                maxSelectableCount
                minSelectableCount
                step
                type
                defaultSelectedCount
                label
                promoId
                restrictionText
                ticketKey
                ticketSingular
                ticketPlural
                prices {
                    selectedCount
                    perTravelerPrice {
                        lead {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                        strikeOut {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                    }
                    totalPrice {
                        lead {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                        strikeOut {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                    }
                    totalLoyaltyPointsOption {
                        pointsAmount {
                            raw
                        }
                        pointsUnit
                        leadingCaption
                        pointsFirst
                        strikeThroughFirst
                    }
                }
            }
            selections {
                id
                title
                fields {
                    label
                    theme
                    value
                }
            }
        }
        recommendation {
            title
        }
    }
}

    `;

export const activityDetailReviewsQuery = templateJoin`
        query ActivityDetailReviews(
    $context: ContextInput!
    $activityId: String!
    $dateRange: ActivityDateRangeInput
    $destination: ActivityDestinationInput
    $sortBy: ActivityReviewSort
    $pagination: PaginationInput
    $source: String
    $detailsViewOptions: [ActivityDetailViewOptions!]
) {
    activityInfo(
        context: $context
        activityId: $activityId
        dateRange: $dateRange
        destination: $destination
        detailsViewOptions: $detailsViewOptions
    ) {
        reviews(sortBy: $sortBy, pagination: $pagination, source: $source) {
            text
            author
            id
            activityDate {
                formatted(format: "MMM dd, yyyy")
                longDateFormat
            }
            submissionDate {
                raw
                formatted(format: "MMM dd, yyyy")
                longDateFormat
            }
            formattedActivityDate
            formattedSubmissionDate
            overallRating {
                formatted
                raw
            }
            reviewedOn
            userLocation
            helpfulVotes {
                count
                message
            }
        }
    }
}

    `;

export const activityPageSeoContentQuery = templateJoin`
        query ActivityPageSeoContent(
    $context: ContextInput!
    $activityId: String
    $pageType: ActivityPageType!
) {
    activitySeoContent(
        context: $context
        activityId: $activityId
        pageType: $pageType
    ) {
        canonicalUrl {
            value
        }
        metaTags {
            content
            metaTagType
            metaTagValue
        }
        hreflangLinks {
            href
            hrefLang
        }
        title
    }
}

    `;
